module.exports = __webpack_public_path__ + "img/icon-jifen.5a58fc4b.png";